import React, { useEffect, useContext } from 'react';
import DedicatedContractCard from './card';

import { Loading } from 'components/Loading';
import { StyledLoading, StyledWrapper } from 'modules/assignment-cards/styled';

import DedicatedContractsAssignmentContext from './context';

const AssingmentDedicatedContracts = ({ filters, vertical, assignActionComponent }) => {
  const { loading, fetchDedicatedContracts, dedicatedContracts } = useContext(
    DedicatedContractsAssignmentContext
  );

  useEffect(() => {
    if (!filters) {
      return;
    }
    fetchDedicatedContracts(filters);
  }, [fetchDedicatedContracts, filters]);

  if (!filters) {
    return null;
  }

  if (loading) {
    return (
      <StyledLoading>
        <Loading />
      </StyledLoading>
    );
  }

  return (
    <StyledWrapper vertical={vertical}>
      {dedicatedContracts.map(({ id }, key) => (
        <DedicatedContractCard
          key={id}
          id={id}
          isFirst={key === 0}
          assignActionComponent={assignActionComponent}
          vertical={vertical}
        />
      ))}
    </StyledWrapper>
  );
};

export default AssingmentDedicatedContracts;
